import React from 'react';
import { useDispatch } from 'react-redux';
import { FORM_NAME, RECORDED_FILE } from './fields';
import { Button } from 'components/button';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';
import { uploadInitVideoObjectRequestAction } from 'pages/upload.page';
import { useTranslation } from 'react-i18next';
import { openRecordAgainConfirmationDialog } from './confirm-record-again-dialog';
import { closeWebcamRecordingDialog } from './index';
import { uploadResetAction } from 'pages/upload.page/actions';

export const PreviewTitle = () => {
  const { t } = useTranslation();
  return <>{t('preview_title')}</>;
};

export const PreviewFooter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { [RECORDED_FILE]: recordedFile } = useSelector(getFormValues(FORM_NAME));

  const onUploadRecording = () => {
    closeWebcamRecordingDialog(dispatch);
    dispatch(uploadResetAction());
    dispatch(uploadInitVideoObjectRequestAction(recordedFile, true));
  };

  const handleRecordAgain = async () => {
    dispatch(openRecordAgainConfirmationDialog());
  };

  return (
    <div className="d-flex justify-content-between">
      <Button secondary onClick={handleRecordAgain}>
        {t('record_again')}
      </Button>
      <Button onClick={onUploadRecording}>{t('upload_recording')}</Button>
    </div>
  );
};

export const PreviewBody = () => {
  const file = useSelector(getFormValues(FORM_NAME))[RECORDED_FILE];

  let url;
  if (file) {
    // TODO: the if statement is aa bit ugly
    // but its needed, because file must be a valid blob
    url = URL.createObjectURL(file);
  }

  return (
    <div className="ct-webcam-mirror">
      <video id="webcam-mirror" controls src={url} className="ct-webcam-video"></video>
    </div>
  );
};
